// BaseStepForm helper functions and data
import { InvestForm } from "@anefi/contexts";
import { LegalInvestForm } from "@anefi/contexts";
import { CountryCode } from "artisn-rn/types";
import dayjs from "dayjs";

export const transformValuesToRequest = (values: Partial<InvestForm>) => {
  const {
    additionalPhone,
    gender,
    birthdate,
    IshomeAddressFiscal,
    totalLiabilities,
    totalAssets,
    totalHeritage,
    homeAddressCountryCode,
    phone,
    ...rest
  } = values ?? {};

  const userToUpdate = {
    additionalPhone: {
      countryCode: "+593",
      countryIsoCode: "EC",
      number: additionalPhone
    },
    phone: {
      countryCode: "+593",
      countryIsoCode: "EC" as CountryCode,
      number: phone!
    },
    gender,
    birthdate: dayjs(birthdate).format("YYYY-MM-DD"),
    additionalInfo: {
      ...rest,
      IshomeAddressFiscal: IshomeAddressFiscal ? "S" : "N",
      personType: "NATURAL",
      homeAddressTypeCode: "D",
      homeAddressProvinceSequence: 1,
      homeAddressProvinceCode: "217",
      homeAddressProvinceName: "Pichincha",
      homeAddressCantonSequence: 2,
      homeAddressCantonCode: "21701",
      homeAddressCantonName: "Quito",
      homeAddressParishSequence: null,
      homeAddressParishCode: "",
      totalLiabilitiesCode: "011",
      totalAssetsCode: "010",
      totalLiabilities: +(totalLiabilities ?? "0"),
      totalAssets: +(totalAssets ?? "0"),
      totalHeritage: +(totalHeritage ?? "0"),
      birthCountryCode: homeAddressCountryCode,
      homeAddressCountryCode,
      homeAddressCountryName: "Ecuador"
    }
  };

  return userToUpdate;
};

export const transformValuesToRequestLegal = (
  values: Partial<LegalInvestForm>
) => {
  const {
    totalLiabilities,
    totalAssets,
    totalIncome,
    totalExpenditure,
    startDate,
    additionalPhone,
    phone,
    ...rest
  } = values ?? {};

  const userToUpdate = {
    additionalPhone: {
      countryCode: "+593",
      countryIsoCode: "EC",
      number: additionalPhone
    },
    phone: {
      countryCode: "+593",
      countryIsoCode: "EC" as CountryCode,
      number: phone!
    },
    additionalInfo: {
      ...rest,
      personType: "LEGAL",
      totalLiabilities: +(totalLiabilities ?? "0"),
      totalAssets: +(totalAssets ?? "0"),
      totalIncome: +(totalIncome ?? "0"),
      totalExpenditure: +(totalExpenditure ?? "0"),
      startDate: dayjs(startDate).format("YYYY-MM-DD"),
      legalPersonTypeCode: "2",
      orgGeoSequenceWorkAddress: "2"
    }
  };

  return userToUpdate;
};
